export default "__VITE_ASSET__DD2eiFl5__"